export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export const getUrlOfFile = (file, default_image= 'avatars/default.jpeg') => {
  try {
    return URL.createObjectURL(file);	 
  } catch (error) {
    return file || './img/' + default_image;	
  }
}

export const getNameStatus = (status) => {
  let result = '';
  switch(status){
    case 1:
      result= 'Aktif';
    break;
    case 0:
      result= 'Tidak Aktif';
    break;
  }
  return result;
}

export const getClassStatus = (status) => {
  let result = 'success';
  switch(status){
    case 1:
      result="success";
    break;
    case 0:
      result="danger";
    break;
  }
  return result;
}

export const str_slug = (string) => {
  var slug = "";
  // Change to lower case
  var titleLower = string.toLowerCase();
  // Letter "e"
  slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
  // Letter "a"
  slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
  // Letter "o"
  slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
  // Letter "u"
  slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
  // Letter "d"
  slug = slug.replace(/đ/gi, 'd');
  // Trim the last whitespace
  slug = slug.replace(/\s*$/g, '');
  // Change whitespace to "-"
  slug = slug.replace(/\s+/g, '-');
  
  return slug;
}

export const get_ext_url = (url) => {
  const pieces = url.split(".");
  return pieces[pieces.length - 1];
}

export const is_image = (file) => {
  return file['type'].split('/')[0] === "image";
}

export const is_image_url = (url) => {
  const pieces = url.split(".");
  const ext = pieces[pieces.length - 1];
  return ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'svg' || ext === 'ico';
}

export const getFileName = (file) => {
  let segment = file.split("/");
  return segment[ segment.length - 1];
}

export const getB3Status = (sts) => {
  let status = '';
  switch(sts){
    case null:
    case '0':
      status = 'Belum Diverifikasi';
    break;
    case '1':
      status = 'Terverifikasi';
    break;
    case '2':
      status = 'Perlu Revisi';
    break;
  }
  return status;
}


export const getB3StatusClass = (sts) => {
  let label = '';
  switch(sts){
    case null:
    case '0':
      label = 'warning';
    break;
    case '1':
      label = 'success';
    break;
    case '2':
      label = 'danger';
    break;
  }
  return label;
}

export const getJenisFasilitas = () => {
  const data = [
    {
      id: '1',
      name: "DIPO/TPS/TPS3R"
    },{
      id: '2',
      name: "BANK SAMPAH"
    },{
      id: '3',
      name: "BPS-RW"
    },{
      id: '4',
      name: "PEMERINTAH (OPD)"
    },{
      id: '5',
      name: "FPSSB3 KOTA"
    },{
      id: '6',
      name: "FPSSB3 KECAMATAN"
    },{
      id: '7',
      name: "COLLECTION POINT"
    }
  ];
  return data;
}

export const getJenisFasilitasById = (id) => {
  if(id){
    const data = getJenisFasilitas();
    let result = data.find(v => v.id === id);
    return result ? result.name : "-";
  } else {
    return "-";
  }
}

export const getTipeFasilitas = () => {
  const data = [
    {
      id: '1',
      name: "TIPE 1"
    },{
      id: '2',
      name: "TIPE 2"
    },{
      id: '3',
      name: "TIPE 3"
    },{
      id: '4',
      name: "TIPE 4"
    },{
      id: '5',
      name: "TPS 3R"
    },{
      id: '6',
      name: "EMPLACEMENT"
    },{
      id: '7',
      name: "BSI"
    },{
      id: '8',
      name: "BSU"
    },
  ];
  return data;
}

export const getTipeFasilitasById = (id) => {
  if(id){
    const data = getTipeFasilitas();
    let result = data.find(v => v.id === id);
    return result ? result.name : "-";
  } else {
    return "-";
  }
}


export const getJenisFasyankes = () => {
  const data = [
    {
      id: '1',
      name: "RS"
    },{
      id: '2',
      name: "Puskesmas"
    },{
      id: '3',
      name: "Klinik"
    },{
      id: '4',
      name: "Tempat Praktik Mandiri"
    },{
      id: '5',
      name: "Apotek"
    },{
      id: '6',
      name: "Unit Transfusi Darah"
    },{
      id: '7',
      name: "Laboratorium Kesehatan"
    },{
      id: '8',
      name: "Optikal"
    },{
      id: '9',
      name: "Fasilitas Pelayanan Kedokteran Untuk Kepentingan Hukum"
    },{
      id: '10',
      name: "Fasilitas Pelayanan Tradisional"
    }
  ];
  return data;
}

export const getJenisFasyankesById = (id) => {
  if(id){
    const data = getJenisFasyankes();
    let result = data.find(v => v.id === id);
    return result ? result.name : "-";
  } else {
    return "-";
  }
}


export const getKepemilikan = () => {
  const data = [
    {
      id: '1',
      name: "KEMENTERIAN KESEHATAN"
    },{
      id: '2',
      name: "PEMERINTAH DAERAH"
    },{
      id: '3',
      name: "TNI/POLRI"
    },{
      id: '4',
      name: "SWASTA"
    }
  ];
  return data;
}

export const getKepemilikanById = (id) => {
  if(id){
    const data = getKepemilikan();
    let result = data.find(v => v.id === id);
    return result ? result.name : "-";
  } else {
    return "-";
  }
}

